import {get as getWebsite} from './services/editor/website';
import Cookies from "js-cookie";
import dashboardModule from "./storeModules/dashboardModule";

const keyCookieOffice = 'officeToken';
export default {
  modules: {
    dashboard: dashboardModule
  },
  state: {
    languages: false,
    user: {},
    token: localStorage.getItem('token') || '',
    office_token: Cookies.get(keyCookieOffice) || '',
    website: false, // website current edit
    files_manager: {
      Files: {},
      Images: {},
      Videos: {}
    }
  },
  getters: {
    user(store) {
      return store.user;
    },

    getOfficeToken(store) {
      return store.office_token;
    },

    getLanguages(store) {
      return store.languages;
    },
    token(store) {
      return store.token;
    },
    filesManager(store) {
      return store.files_manager;
    },
    website: state => state.website
  },
  mutations: {
    user(state, user) {
      state.user = user;
    },

    office_token(state, token) {
      state.office_token = token;
    },

    filesManager(state, files_manager) {
      state.files_manager = files_manager;
    },

    website(state, website) {
      state.website = website;
    },

    languages(state, languages) {
      state.languages = languages;
    },
  },
  actions: {
    updateUser(store, user) {
      store.commit('user', user);
    },
    updatetoken(store, token) {
      store.commit('token', token);
    },
    updateOfficeToken(store, token) {
      store.commit('office_token', token);

      Cookies.set(keyCookieOffice, token, { expires: 3 });
      const element = document.getElementsByTagName('builderall-appshell');
      if (element.length)
        element[0].setAttribute('token', token);

    },
    updateFilesManager(store, files) {
      store.commit('files', files);
    },
    clearWebsite(store) {
      store.commit('files', false);
    },
    updateWebsite({commit, state}, websiteIdEncrypted, force = false) {

      if (force || !(state.website)) {

        return new Promise((resolve, reject) => {
          getWebsite(websiteIdEncrypted)
            .then(response => {
              // console.log('response', response);
              commit('website', response.data);
              resolve(response.data);

              // console.log('force || !(state.website)', force || !(state.website), force, !state.website);
            })
            .catch(err => {
              console.log(err);
              reject(err);
            });
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/js/store.js